/* global google */

import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import * as actions from './actions';
import { track } from 'shared/models/analytic';
import Pin from 'images/pin-no-profile-image.png';
import { isRejectedOrder } from 'shared/models/order';
import OrderTracking from './';

class OrderStatus extends React.Component {
  componentDidMount() {
    track('Order Tracking Viewed');

    this.timer = setInterval(this.update.bind(this), 30000);

    let order = this.props.order;
    let address = order.delivery_address_detail;
    let location = order.location || {};
    let coordinates = location.coordinates || [];
    let lat = address.lat || coordinates[1];
    let lng = address.lng || coordinates[0];
    let center = { lat, lng };
    let map = new google.maps.Map(document.getElementById('order-map'), {
      center: center,
      zoom: 15,
      disableDefaultUI: true,
      draggable: false,
      scrollwheel: false
    });
    new google.maps.Marker({
      position: center,
      map: map,
      icon: Pin
    });
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  update() {
    if (this.props.getStatus) this.props.getStatus(this.props.order._id);
  }

  _getDeliveryCopy(status) {
    let driver = this.props.order.driver || { first_name: '' };
    let map = {
      0: {
        title: 'We received your order',
        desc:
          'We have received your order. We are confirming it with the retailer.'
      },
      1: {
        title: 'Your order has been confirmed',
        desc: 'Yay! You are one step closer to getting your order.'
      },
      2: {
        title: `${driver.first_name} is on the way!`,
        desc: `${driver.first_name} is on the way and can't wait to deliver your order.`
      },
      3: {
        title: 'Delivered. Cheers ;)',
        desc: 'We hope you enjoy your order. Thanks for choosing Saucey.'
      },
      7: {
        title: 'Your order has been picked up',
        desc: "We have picked up your order. We'll be on our way shortly"
      }
    };
    return map[status] || { title: '', desc: '' };
  }

  _getShippingCopy(status) {
    switch (status) {
      case 'Shipped':
        return {
          title: 'Order Shipped',
          desc: 'Your order has shipped.'
        };
      case 'Completed':
        return {
          title: 'Delivered. Cheers ;)',
          desc: 'We hope you enjoy your order. Thanks for choosing Saucey.'
        };
      default:
        return {
          title: 'We received your order',
          desc:
            "When your order ships, you'll receive an email with a tracking link. Cheers."
        };
    }
  }

  render() {
    this.shipping = this.props.order.shipping;

    this.status = {};
    this.order = this.props.order;
    this.order.order_events.forEach(
      (item => {
        this.status[item.value] = {
          ...item,
          time: moment(item.timestamp).format('h:mm a')
        };
      }).bind(this)
    );

    this.currentStatus = this.shipping
      ? this.order.shipping_status
      : this.order.order_status;
    const { title, desc } = this.shipping
      ? this._getShippingCopy(this.currentStatus)
      : this._getDeliveryCopy(this.currentStatus);
    this.title = title;
    this.description = desc;

    if (
      typeof window !== 'undefined' &&
      this.currentStatus == 3 &&
      !this.shipping
    ) {
      setTimeout(() => (window.location = '/tip/' + this.order._id), 5000);
    }

    if (
      typeof window !== 'undefined' &&
      isRejectedOrder(this.order) &&
      !this.shipping
    ) {
      setTimeout(
        () => (window.location = '/substitution/' + this.order._id),
        5000
      );
    }

    return (
      <OrderTracking>
        <div className="order-tracking-status order-tracking-container">
          <div id="order-map" />
          <h1 className="order-tracking-status-title">{this.title}</h1>
          <span className="order-tracking-status-separator" />
          <span className="order-tracking-status-description">
            {this.description}
          </span>

          {!this.shipping ? (
            <div className="order-tracking-status-progress">
              <div className="progress-step active">
                <div className="progress-step-item">
                  <span className="progress-step-icon" />
                  <span className="progress-step-line" />
                </div>
                <span className="progress-step-label text-bold">
                  Order Received
                </span>
                <span className="progress-step-time">
                  {this.status[0].time}
                </span>
              </div>
              <div
                className={
                  'progress-step' +
                  ([1, 2, 3, 7].indexOf(this.currentStatus) != -1
                    ? ' active'
                    : '')
                }
              >
                <div className="progress-step-item">
                  <span className="progress-step-line" />
                  <span className="progress-step-icon" />
                  <span className="progress-step-line" />
                </div>
                <span className="progress-step-label text-bold">Confirmed</span>
                <span className="progress-step-time">
                  {this.status[1] ? this.status[1].time : ''}
                </span>
              </div>
              <div
                className={
                  'progress-step' +
                  ([2, 3, 7].indexOf(this.currentStatus) != -1 ? ' active' : '')
                }
              >
                <div className="progress-step-item">
                  <span className="progress-step-line" />
                  <span className="progress-step-icon" />
                  <span className="progress-step-line" />
                </div>
                <span className="progress-step-label text-bold">Picked Up</span>
                <span className="progress-step-time">
                  {this.status[7] ? this.status[7].time : ''}
                </span>
              </div>
              <div
                className={
                  'progress-step' +
                  ([2, 3].indexOf(this.currentStatus) != -1 ? ' active' : '')
                }
              >
                <div className="progress-step-item">
                  <span className="progress-step-line" />
                  <span className="progress-step-icon" />
                  <span className="progress-step-line" />
                </div>
                <span className="progress-step-label text-bold">
                  On The Way
                </span>
                <span className="progress-step-time">
                  {this.status[2] ? this.status[2].time : ''}
                </span>
              </div>
              <div
                className={
                  'progress-step' + (this.currentStatus == 3 ? ' active' : '')
                }
              >
                <div className="progress-step-item">
                  <span className="progress-step-line" />
                  <span className="progress-step-icon" />
                </div>
                <span className="progress-step-label text-bold">Delivered</span>
                <span className="progress-step-time">
                  {this.status[3] ? this.status[3].time : ''}
                </span>
              </div>
            </div>
          ) : (
            <div className="order-tracking-status-progress">
              <div className="progress-step active">
                <div className="progress-step-item">
                  <span className="progress-step-icon" />
                  <span className="progress-step-line progress-step-line--wide" />
                </div>
                <span className="progress-step-label progress-step-label--wide text-bold">
                  Order Received
                </span>
              </div>
              <div
                className={
                  'progress-step' +
                  (['Shipped', 'Completed'].indexOf(this.currentStatus) != -1
                    ? ' active'
                    : '')
                }
              >
                <div className="progress-step-item">
                  <span className="progress-step-line progress-step-line--wide" />
                  <span className="progress-step-icon" />
                  <span className="progress-step-line progress-step-line--wide" />
                </div>
                <span className="progress-step-label text-bold">
                  Order Shipped
                </span>
              </div>
              <div
                className={
                  'progress-step' +
                  (this.currentStatus === 'Completed' ? ' active' : '')
                }
              >
                <div className="progress-step-item">
                  <span className="progress-step-line progress-step-line--wide" />
                  <span className="progress-step-icon" />
                </div>
                <span className="progress-step-label progress-step-label--wide text-bold">
                  Delivered
                </span>
              </div>
            </div>
          )}
        </div>
      </OrderTracking>
    );
  }
}

function mapStateToProps(state) {
  return { ...state.orderTracking };
}

export default connect(mapStateToProps, { ...actions })(OrderStatus);



// WEBPACK FOOTER //
// ./shared/components/orderTracking/status.js